/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  EpkModuleApiService,
  getFilteredData,
} from '~packages/epk-front-shared/api-client';
import type { Filters, Params } from '~packages/epk-front-shared/api-client';
import { Mode, RequestMethod } from '~packages/json-api/client';
import replacePlaceholdersCustom, {
  PathParts,
} from '~packages/json-api/client/helpers/__base/replacePlaceholdersCustom';

import getConstants from '@/shared/constants';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'ExtractsApiService',
  mode: isModeDevelopment ? Mode.Production : Mode.Production,
  // needInit: isModeDevelopment,
};

export interface IFetchAllResponse {
  data: any[];
  [k: string]: any;
}

export default class ExtractsApiService extends EpkModuleApiService {
  printPath;

  constructor() {
    super(constructorParams);
    this.printPath = `/prints/{mode}/{uuid}`;
    // console.log(28, { basePath: this.basePath, printPath: this.printPath });
  }

  async getExtractById(headPoint: string) {
    return await this._sendRequest(`/doc/${headPoint}`, undefined, undefined, {
      method: 'getExtract',
    });
  }

  async print(parts: IPrintParts, params?: Record<string, unknown>) {
    if (parts) {
      const partsMode = {
        'extract-full': 'v1/full',
        'extract-free': 'v1/free',
        'extract-npzu': 'npzu/v1',
      }[parts.mode];
      if (!partsMode) {
        console.error('Не удалось сформировать url из params=', params);
        return;
      }

      parts.mode = partsMode;
    }

    return await this._sendRequest(
      replacePlaceholdersCustom(this.printPath, parts as unknown as PathParts),
      params,
      { method: RequestMethod.POST },
      { method: 'print' }
    );
  }

  async printRPCFull(cacheGuid: string) {
    return await this._sendRequest(
      `/prints/v1/full/${cacheGuid}`,
      undefined,
      { method: RequestMethod.POST },
      {
        method: 'printExtractsFull',
        options: { headers: { 'rpc-execute': true } },
      }
    );
  }

  async printRPCFree(cacheGuid: string) {
    return await this._sendRequest(
      `/prints/v1/free/${cacheGuid}`,
      undefined,
      { method: RequestMethod.POST },
      {
        method: 'print',
        options: { headers: { 'rpc-execute': true } },
      }
    );
  }

  async printRPCNpzu(cacheGuid: string) {
    return await this._sendRequest(
      `/prints/npzu/v1/${cacheGuid}`,
      undefined,
      { method: RequestMethod.POST },
      {
        method: 'print',
        options: { headers: { 'rpc-execute': true } },
      }
    );
  }

  async addExtractRPC(data: unknown) {
    return await this._sendRequest(
      this.pathAdd,
      undefined,
      { body: this.jsonStringify(data), method: this.requestMethodAdd },
      { method: 'addExtractRPC', options: { headers: { 'rpc-execute': true } } }
    );
  }

  async approveExtractRPC(point_code: string, url: string) {
    const path = `/${point_code}/commit-eds`;
    const params = {};
    const data = { url };
    const response = await super._sendRequest(
      path,
      params,
      { body: JSON.stringify(data), method: RequestMethod.PUT },
      {
        method: 'upload',
        options: { headers: { 'rpc-execute': true } },
      }
    );
    return response;
  }

  async approveExtract(point_code: string, url: string) {
    const path = `/${point_code}/commit-eds`;
    const params = {};
    const data = { url };
    const response = await super._sendRequest(
      path,
      params,
      { body: JSON.stringify(data), method: RequestMethod.PUT },
      { method: 'upload' }
    );
    return response;
  }

  async rollbackExtract(point_code: string) {
    return await super.update({}, `${point_code}/drop-commit-eds`);
  }

  async dataGet(
    { route, uuid }: { route: string; uuid: string },
    params?: Record<string, unknown>
  ) {
    return await this._sendRequest(
      `/data/${route}/${uuid}`,
      params,
      undefined,
      { method: 'dataGet' }
    );
  }

  async getSectionsSystem(params) {
    return await super.fetch(params);
  }

  async getFilteredData(filters: Filters, params: Params) {
    return await getFilteredData(this, filters, params);
  }

  async modalWindowAccounts(_parts: unknown, params: { headPoint: bigint }) {
    return await this._sendRequest(
      '/modal-window/accounts',
      { head_point: params.headPoint },
      undefined,
      { method: 'modalWindowAccounts' }
    );
  }

  async modalWindowEpk(
    _parts: unknown,
    params: { account: string; headPoint: bigint }
  ) {
    return await this._sendRequest(
      '/modal-window/epk',
      { account: params.account, head_point: params.headPoint },
      undefined,
      {
        method: 'modalWindowEpk',
      }
    );
  }

  async modalWindowHeads(filters: Filters, params: Params) {
    return await getFilteredData(
      this,
      filters,
      params,
      {},
      {},
      '/modal-window/heads'
    );
  }

  async modalWindowMembers(dto: {
    account: string;
    dim_members_head_point: bigint;
    periods: string[];
  }) {
    // const data = [
    //   {
    //     members_fio: 'Константиновский Андрей Игоревич',
    //     members_nsiRelToHead_name: 'Глава хозяйства',
    //   },
    //   {
    //     members_fio: 'Константиновский Михаил Игоревич',
    //     members_nsiRelToHead_name: 'Брат',
    //   },
    //   {
    //     members_fio: 'Иванов Никита Игоревич',
    //     members_nsiRelToHead_name: 'Племянник',
    //   },
    //   {
    //     members_fio: 'Константиновская Елена Викторовна',
    //     members_nsiRelToHead_name: 'Жена',
    //   },
    //   {
    //     members_fio: 'Константиновская Арина Андреевна',
    //     members_nsiRelToHead_name: 'Дочь',
    //   },
    //   {
    //     members_fio: 'Соколова Алена Викторовна',
    //     members_nsiRelToHead_name: 'Племянница',
    //   },
    //   {
    //     members_fio: 'Ковалева Наталья Викторовна',
    //     members_nsiRelToHead_name: 'Невестка',
    //   },
    //   {
    //     members_fio: 'Константиновская Марина Андреевна',
    //     members_nsiRelToHead_name: 'Дочь',
    //   },
    //   {
    //     members_fio: 'Соколова Ксения Викторовна',
    //     members_nsiRelToHead_name: 'Племянница',
    //   },
    //   {
    //     members_fio: 'Соколова Ксения Викторовна1',
    //     members_nsiRelToHead_name: 'Племянница',
    //   },
    // ];

    // return { status: true, response: { data } };

    return await this._sendRequest(
      '/modal-window/members',
      { use_pagination: false },
      { body: this.jsonStringify(dto), method: RequestMethod.POST },
      { method: 'modalWindowMembers' }
    );
  }

  async modalWindowPeriods(
    _parts: unknown,
    params: { account: string; epk: number; headPoint: bigint }
  ) {
    return await this._sendRequest(
      '/modal-window/periods',
      {
        account: params.account,
        epk: params.epk,
        head_point: params.headPoint,
      },
      undefined,
      {
        method: 'modalWindowPeriods',
      }
    );
  }

  async deleteByCode(code: string) {
    return await this._sendRequest(
      `/${code}`,
      undefined,
      { method: RequestMethod.DELETE },
      { method: 'delete' }
    );
  }
}
